<template>
    <div
        class="slot hourslot"
        :style="
            $options.getStyle(
                itemSlotMapping,
                itemId,
                hour,
                date,
            )
        "
        @click="$options.handleClick(itemSlotMapping)"
        @contextmenu.prevent="$options.handleRightClick($event, itemSlotMapping)"
    >
        <div
            class="slot-edge slot-start"
            v-if="$options.firstOfDay(itemSlotMapping, hour)"
        >
            <div class="spacer"></div>
            <div class="dragger" :style="$options.slotEdgeStyle(itemSlotMapping)"></div>
        </div>
        <div
            class="slot-info"
            :style="$options.slotInfoStyle(itemSlotMapping)"
            :key="'slot-info-' + itemSlotMapping.id"
            :draggable="true"
            @dragstart="
                $options.handleDragStart($event, itemSlotMapping, itemId, hour)
            "
            @dragend.prevent="$options.handleDragEnd($event)"
            @mouseover="$options.handleMouseOver($event, itemSlotMapping)"
        >
            <div
                class="titles"
                :style="$options.getTitleStyle(itemSlotMapping, date)"
                v-if="$options.firstOfDay(itemSlotMapping, hour)"
                v-html="$options.getTitle(itemSlotMapping)"
            ></div>
        </div>
        <div
            class="slot-edge slot-end"
            v-if="$options.lastOfDay(itemSlotMapping, hour)"
        >
            <div class="dragger" :style="$options.slotEdgeStyle(itemSlotMapping)"></div>
            <div class="spacer"></div>
        </div>
    </div>
</template>

<script>
import store from '../../stores';
import { timeToMinutes } from '../../utils/timeToMinutes';
import { emitter } from '../../plugins/Mitt';
import { ZOOM_SETTINGS } from '../../constants';
import { difference } from 'lodash';
import {getSlotStyling} from "../../utils/planning/getSlotStyling";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
        hour: {
            type: Number,
            required: true,
        },
        date: {
            type: Object,
            required: true,
        },
        itemSlotMapping: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    getStyle(itemSlotMapping, itemId, hour, date) {
        const height = store.state.planning.slotTitlesHeigth;
        const hourRow = itemSlotMapping.hourRow;
        const posY = 5 /*margin start*/ + hourRow * (height + 5); /*margin*/

        const draggedSlot = store.state.planning.dragStartInfo.draggedSlot;
        const mode = store.state.planning.mode;
        let slotItemId = null;
        if (draggedSlot && mode === 'project') {
            slotItemId = draggedSlot.taskId;
        } else if (draggedSlot && mode === 'person') {
            slotItemId = draggedSlot.personId;
        } else if (draggedSlot && mode === 'team') {
            slotItemId = draggedSlot.teamId;
        }

        const firstOfDay = this.firstOfDay(itemSlotMapping, hour);
        const zIndex = firstOfDay ? 2 : 1;

        const currentHourMinutesStart = timeToMinutes(hour + ':00');
        const currentHourMinutesEnd = timeToMinutes(hour + 1 + ':00');
        const minuteWidth =
            ZOOM_SETTINGS[0].dayWidth[date.localDate.dayOfWeek().value()] / (60 * 24);

        let marginLeft = null;
        let marginRight = null;
        let maxWidth = null;
        let totalMinutesToShow = 60;
        if (firstOfDay) {
            const minutesStart = timeToMinutes(itemSlotMapping.timeStart);
            if (minutesStart !== currentHourMinutesStart) {
                const minutesToShow = currentHourMinutesEnd - minutesStart;
                totalMinutesToShow = totalMinutesToShow - (60 - minutesToShow);
                marginLeft = (60 - minutesToShow) * minuteWidth + 'px';
            }
        }

        const lastOfDay = this.lastOfDay(itemSlotMapping, hour);
        if (lastOfDay) {
            const minutesEnd = timeToMinutes(itemSlotMapping.timeEnd);
            if (minutesEnd !== currentHourMinutesEnd) {
                const minutesToHide = currentHourMinutesEnd - minutesEnd;
                totalMinutesToShow = totalMinutesToShow - minutesToHide;
                marginRight = minutesToHide * minuteWidth + 'px';
            }
        }

        if (totalMinutesToShow !== 60) {
            maxWidth = totalMinutesToShow * minuteWidth + 'px';
        }

        return {
            maxWidth: maxWidth,
            marginLeft: marginLeft,
            marginRight: marginRight,
            height: height + 'px',
            transform: 'translateY(' + posY + 'px)',
            zIndex: zIndex,
        };
    },
    slotInfoStyle(itemSlotMapping) {
        const slotStyling = getSlotStyling(store, itemSlotMapping);
        return {
            backgroundColor: slotStyling.backgroundColor,
            backgroundImage: slotStyling.backgroundImage,
        };
    },
    slotEdgeStyle(itemSlotMapping) {
        const slotStyling = getSlotStyling(store, itemSlotMapping);
        return {
            backgroundColor: slotStyling.darkenBackgroundColor,
        };
    },
    getTitleStyle(itemSlotMapping, date) {
        const startMinutes = timeToMinutes(itemSlotMapping.timeStart);
        const endMinutes = timeToMinutes(itemSlotMapping.timeEnd);
        const totalMinutes = endMinutes - startMinutes;

        const minuteWidth =
            ZOOM_SETTINGS[0].dayWidth[date.localDate.dayOfWeek().value()] / (60 * 24);

        let titleWidth = totalMinutes * minuteWidth - 8;
        titleWidth = titleWidth > 0 ? titleWidth : 0;

        const slotStyling = getSlotStyling(store, itemSlotMapping);
        return {
            pointerEvents: 'none',
            width: titleWidth + 'px',
            color: slotStyling.color,
        };
    },
    getTitle: function (itemsSlotsMapping) {
        const mode = store.state.planning.mode;

        const timings =
            '<br><small>' +
            itemsSlotsMapping.timeStart +
            ' - ' +
            itemsSlotsMapping.timeEnd +
            '</small>';

        const persons = store.state.planning.persons;
        const slotPersons = itemsSlotsMapping.persons;
        let teamsForSlot = {};
        let personsAmount = 0;
        let hasIncompleteTeam = false;
        Object.values(slotPersons).forEach((person) => {
            if (person.teams.length > 0) {
                person.teams.forEach((team) => {
                    teamsForSlot[team] = team;

                    let teamObject = store.state.planning.teams[team];
                    const amountPersonsMissing = difference(
                        teamObject.persons,
                        Object.keys(slotPersons).map(Number),
                    ).length;
                    if (amountPersonsMissing > 0) {
                        hasIncompleteTeam = true;
                    }
                });
                return;
            }
            personsAmount++;
        });

        let subTitle = '';
        const teamsAmount = Object.keys(teamsForSlot).length;
        if (teamsAmount > 0) {
            subTitle +=
                '<i class="icofont-people"></i>' + teamsAmount + (hasIncompleteTeam ? '!' : '');
        }
        if (personsAmount) {
            subTitle += '<i class="icofont-user"></i>' + personsAmount;
        }
        if (itemsSlotsMapping.repeatedSettingsId) {
            subTitle = '<i class="icofont-retweet"></i>' + subTitle;
        }
        switch (mode) {
            case 'project':
                let teamTitle = '';

                if (teamsAmount > 0) {
                    const slotTeams = itemsSlotsMapping.teams;
                    const team = store.state.planning.teams[Object.keys(slotTeams)[0]];
                    teamTitle = team.title;
                }

                let personTitle = '';
                if (personsAmount > 0) {
                    const person = persons[Object.keys(slotPersons)[0]];
                    personTitle = person.last_name + ' ' + (person.first_name ?? '');
                    personTitle = personTitle.trim();
                }
                let title = teamTitle ? teamTitle : personTitle;

                if (!title) {
                    const task = store.state.planning.tasks[itemsSlotsMapping.taskId];
                    title = task.title;
                }
                return title + '<br>' + subTitle + timings;
            case 'team':
            case 'person':
            default:
                const task = store.state.planning.tasks[itemsSlotsMapping.taskId];
                const taskTitle = task.title;
                const projectTitle = task.project?.title ?? '';
                const projectInternalId = task.project?.internal_id ?? '';
                const client = task.client?.title ?? '';

                const slotTitles = store.state.planning.slotTitles;

                let slotTitle = '';
                Object.keys(slotTitles).forEach((entity) => {
                    if (!slotTitles[entity]) {
                        return;
                    }
                    switch (entity) {
                        case 'task':
                            slotTitle += taskTitle ? taskTitle + '<br>' : '';
                            break;
                        case 'project':
                            slotTitle += projectTitle ? projectTitle + '<br>' : '';
                            break;
                        case 'project_internal_number':
                            slotTitle += projectInternalId ? projectInternalId + '<br>' : '';
                            break;
                        case 'client':
                            slotTitle += client ? client + '<br>' : '';
                            break;
                    }
                });

                return slotTitle + subTitle + timings;
        }
    },
    firstOfDay(itemSlotMapping, hour) {
        const startMinutes = timeToMinutes(itemSlotMapping.timeStart);
        const currentHourMinutesStart = timeToMinutes(hour + ':00');
        const currentHourMinutesEnd = timeToMinutes(hour + 1 + ':00');
        return startMinutes >= currentHourMinutesStart && startMinutes < currentHourMinutesEnd;
    },
    lastOfDay(itemSlotMapping, hour) {
        const endMinutes = timeToMinutes(itemSlotMapping.timeEnd);
        const currentHourMinutesStart = timeToMinutes(hour + ':00');
        const currentHourMinutesEnd = timeToMinutes(hour + 1 + ':00');
        return endMinutes > currentHourMinutesStart && endMinutes <= currentHourMinutesEnd;
    },
    handleDragStart($event, itemSlotMapping, itemId, hour) {
        emitter.emit('hide-slot-hover-info');
        emitter.emit('hide-day-hover-info');
        const body = document.body;
        body.classList.add('cursor-grabbing');

        const dragInfoElement = document.querySelector('.drag-info');
        $event.dataTransfer.setDragImage(dragInfoElement, 0, 0);

        const xPosition = $event.clientX - $event.target.getBoundingClientRect().left; //x position within the element.
        const xRelativePosition = xPosition / $event.target.getBoundingClientRect().width;
        const minutes = Math.ceil((60 * xRelativePosition) / 5) * 5;
        const dragTime = ('0' + hour).slice(-2) + ':' + ('0' + minutes).slice(-2);

        let startDrag = {
            slotId: itemSlotMapping.id,
            date: itemSlotMapping.date,
            localDate: itemSlotMapping.localDate,
            firstSlotId: itemSlotMapping.firstSlotId,
            taskId: itemSlotMapping.taskId,
            dragTime: dragTime,
        };

        const mode = store.state.planning.mode;

        if (mode === 'person') {
            startDrag.personId = itemId;
        } else if (mode === 'team') {
            startDrag.teamId = itemId;
        }

        store.commit('planning/setDragStartData', startDrag);
    },
    handleDragEnd($event) {
        document.body.classList.remove('cursor-grabbing');
        setTimeout(() => {
            store.commit('planning/setDragEnd');
        }, 200);
    },
    handleClick(itemSlotMapping) {
        emitter.emit('open-planning-form', {
            slotId: itemSlotMapping.id,
        });
    },
    handleRightClick(event, itemSlotMapping) {
        let eventObject = {
            slot: itemSlotMapping,
        };
        emitter.emit('show-context-menu-component', { eventObject: eventObject, event: event });
    },
    handleMouseOver($event, itemSlotMapping) {
        if (store.state.planning.isDragging) {
            return;
        }
        emitter.emit('show-slot-hover-info', {
            slotId: itemSlotMapping.firstSlotId ?? itemSlotMapping.id,
            event: $event,
        });
    },
};
</script>

<style lang="scss">
.slot.hourslot {
    .slot-edge {
        .dragger {
            width: 5px;
        }
        .spacer {
            width: 0;
            pointer-events: none;
        }
    }
}
</style>
